'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var client = require('@apollo/client');
var nthHookContextPage = require('@narvar/nth-hook-context-page');
var graphql = require('./graphql.js');

var index = ({
  eddCombos,
  ...queryOptions
}) => {
  const {
    state
  } = nthHookContextPage.usePageContext();
  const {
    localeLanguage,
    localeCountry,
    retailerMoniker,
    versionName
  } = state;
  return client.useQuery(graphql["default"], {
    variables: {
      eddCombos,
      retailerMoniker,
      versionName,
      localeLanguage,
      localeCountry
    },
    ...queryOptions
  });
};

exports.formatEddQuery = graphql["default"];
exports["default"] = index;
